import React from "react";

const ServiceDescription = ({ title, content }) => {
  return (
    <div className=" w-full pt-4 bg-primary">
      <div className="min-h-1/3 max-w-screen-xl  w-[80%]  bg-primary mx-auto  flex-col w-fit">
        <h1 className=" text-4xl  sm:text-8xl  w-full text-center sm:py-10 sm:pb-10 font-bold ">
          {title}
        </h1>
        <p className=" sm:text-2xl font-bold pb-6 pl-6 sm:pb-10 mx-auto  w-fit">
          {content}
        </p>
      </div>
    </div>
  );
};

export default ServiceDescription;
